export default __webpack_public_path__ + "static/media/videoviews.b7873220.png";